/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate monthly SIP returns`)
};

const es_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima retornos de SIP mensuales`)
};

const de_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzen Sie die monatliche SIP-Rendite`)
};

const nl_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat maandelijkse SIP-rendement`)
};

const fr_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez les rendements SIP mensuels`)
};

const it_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima i rendimenti mensili del SIP`)
};

const pt_br2_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime retornos de SIP mensal`)
};

const pt_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime os retornos mensais do SIP`)
};

const ja_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月次SIPの返却額を推定`)
};

const zh_sip_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`估算每月SIP收益`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_nav_main_desc", locale)
	if (locale === "en") return en_sip_nav_main_desc(inputs)
	if (locale === "es") return es_sip_nav_main_desc(inputs)
	if (locale === "de") return de_sip_nav_main_desc(inputs)
	if (locale === "nl") return nl_sip_nav_main_desc(inputs)
	if (locale === "fr") return fr_sip_nav_main_desc(inputs)
	if (locale === "it") return it_sip_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_sip_nav_main_desc(inputs)
	if (locale === "pt") return pt_sip_nav_main_desc(inputs)
	if (locale === "ja") return ja_sip_nav_main_desc(inputs)
	return zh_sip_nav_main_desc(inputs)
};